import { motion } from "framer-motion";
import img3 from "../assets/projects-images/reluxrent/creating-apartment.JPG";
import img4 from "../assets/projects-images/reluxrent/earnings.JPG";
import img2 from "../assets/projects-images/reluxrent/language-currency-popup.JPG";
import img1 from "../assets/projects-images/reluxrent/single-apartment.JPG";
import image from "../assets/reluxrent-cover.JPG";

import BackToTop from "../components/BackToTop";
import ProjectHeader from "../components/ProjectHeader";
import ProjectsLinks from "../components/ProjectsLinks";
import { fadeIn } from "../variants";

const projectImages = [
  {
    id: 1,
    img: img1,
    title: "Single Apartment Page",
    fade: "left",
  },
  {
    id: 2,
    img: img2,
    title: "Language & Currency Popup",
    fade: "right",
  },
  {
    id: 3,
    img: img3,
    title: "Creating Apartment Page",
    fade: "left",
  },
  {
    id: 4,
    img: img4,
    title: "Earnings History Page",
    fade: "right",
  },
];

const Reluxrent = () => {
  return (
    <div className="container mx-auto">
      {/* Header */}
      <ProjectHeader />
      {/* Back to Top */}
      <BackToTop />
      {/* Project Info */}
      <div className="grid grid-cols-1 lg:grid-cols-2 justify-center gap-2 items-center">
        {/* Text */}
        <motion.div
          variants={fadeIn("left", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.7 }}
        >
          <h2 className="text-[40px] font-bold leading-[0.8] mb-4">
            Relux<span className="text-accent">Rent</span>
          </h2>
          <h3 className="mb-4 text-xl md:text-[20px] font-secondary font-semibold uppercase leading-[1]">
            A Property Booking & Rental Platform
          </h3>
          <p className="text-[16px]">
            <span className=" font-semibold text-lg">Technologies:</span> Next.js, React, Prisma, MySQL, Express.js, TailwindCSS, Firebase, JWT, Socket.io, Node.js
            <br />
            ● Built rental platform with listings, bookings, payments, and
            availability. <br />
            ● Implemented secure Firebase Auth/JWT with OTP and roles. <br />
            ● Designed dashboard for property and booking management. <br />
            ● Added real-time chat, notifications, and responsive UI. <br />
          </p>
        </motion.div>
        {/* Image */}
        <motion.div
          variants={fadeIn("right", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: true, amount: 0.7 }}
        >
          <img
            className="w-full min-h-[180px] lg:min-h-[270px] group-hover:scale-125 transition-all duration-500 object-cover rounded-lg"
            src={image}
            alt="Project Banner"
          />
        </motion.div>
      </div>
      <ProjectsLinks
        github={"https://github.com/yasinarafat4/reluxrent"}
        live={"https://reluxrent.com/"}
      />
      {/* Project Images */}
      <h2 className="text-[40px] font-bold leading-[0.8] mb-4 text-center pt-10 pb-4">
        Project <span className="text-accent">Images</span>
      </h2>
      <div className="lg:grid grid-cols-2 gap-6">
        {projectImages.map((project) => (
          <motion.div
            key={project.id}
            variants={fadeIn(project.fade, 0.3)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            className="m-4"
          >
            <div className="group relative overflow-hidden border-2 border-white/50 rounded-xl cursor-pointer w-full z-40">
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-300"></div>

              {/* Image */}
              <img
                className="w-full min-h-[180px] lg:min-h-[270px] object-cover group-hover:scale-110 transition-all duration-500"
                src={project.img}
                alt={project.title}
              />

              {/* Hover Text */}
              <div className="absolute inset-0 flex items-end group-hover:items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 z-50">
                <span className="text-white text-xl md:text-2xl lg:text-3xl font-semibold text-center">
                  {project.title}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Reluxrent;
